import requestAction from '../../utils/requestAction'

export const fetchProductBrands = (params: string = "") =>
  requestAction('PRODUCTBRAND_LIST', params)(`productBrands`, 'GET')

export const fetchAllProductBrands = () =>
  fetchProductBrands('?all=true')